import { getMethods as getPropertiesMethods } from './Properties';
import { getMethods as getPropertyTypesMethods } from './PropertyTypes';
import { getMethods as getPropertyTypesMLMethods } from './PropertyTypesML';
import { getMethods as getMaintenanceMethods } from './Maintenance';
import { getMethods as getUsersMethods } from './Users';
import { getMethods as getPositionsMethods } from './Positions';
import { getMethods as getProfessionsMethods } from './Professions';
import { getMethods as getPropertyValuesMethods } from './PropertyValues';
import { getMethods as getDepartmentMethods } from './Department';
import { getMethods as getCompaniesMethods } from './Companies';
import { getMethods as getCompanyObjectsMethods } from './CompanyObjects';
import { getMethods as getGroupsMethods } from './Groups';
import { getMethods as getGroupContentsMethods } from './GroupContents';
import { getMethods as getUserManagersMethods } from './UserManagers';
import { getMethods as getManagerKeysMethods } from './ManagerKeys';
import { getMethods as getShiftsMethods } from './Shifts';
import { getMethods as getOvertimesMethods } from './Overtimes';
import { getMethods as getSalariesMethods } from './Salaries';
import { getMethods as getUserSettingsMethods } from './UserSettings';
import { getMethods as getCompanyAdminsMethods } from './CompanyAdmins';

const getController = (service: 'hr') => ({
	Properties: getPropertiesMethods(service, 'Properties'),
	PropertyTypes: getPropertyTypesMethods(service, 'PropertyTypes'),
	PropertyTypesML: getPropertyTypesMLMethods(service, 'PropertyTypesML'),
	Maintenance: getMaintenanceMethods(service, 'Maintenance'),
	Users: getUsersMethods(service, 'Users'),
	Positions: getPositionsMethods(service, 'Positions'),
	Professions: getProfessionsMethods(service, 'Professions'),
	PropertyValues: getPropertyValuesMethods(service, 'PropertyValues'),
	Department: getDepartmentMethods(service, 'Department'),
	Companies: getCompaniesMethods(service, 'Companies'),
	CompanyObjects: getCompanyObjectsMethods(service, 'CompanyObjects'),
	Groups: getGroupsMethods(service, 'Groups'),
	GroupContents: getGroupContentsMethods(service, 'GroupContents'),
	UserManagers: getUserManagersMethods(service, 'UserManagers'),
	ManagerKeys: getManagerKeysMethods(service, 'ManagerKeys'),
	Shifts: getShiftsMethods(service, 'Shifts'),
	Overtimes: getOvertimesMethods(service, 'Overtimes'),
	Salaries: getSalariesMethods(service, 'Salaries'),
	UserSettings: getUserSettingsMethods(service, 'UserSettings'),
	CompanyAdmins: getCompanyAdminsMethods(service, 'CompanyAdmins')
});

export { getController };
